import flatpickr from 'flatpickr';

/**
 * Unified date picker init — Phase 183 (INPUT-01, D-11, D-13, D-15)
 *
 * Selects all [data-picker="date"] inputs and initializes flatpickr with the
 * locked config (dateFormat Y-m-d + allowInput:true).
 *
 * Idempotency guard: flatpickr sets `_flatpickr` on the element after init.
 * Checking it prevents double-init when shared.init() runs on every page.
 *
 * disableMobile is intentionally NOT set (default = false) so mobile users get
 * the native OS date picker (D-11/INPUT-04).
 */
export function initPickers(): void {
    const inputs = document.querySelectorAll<HTMLInputElement>('[data-picker="date"]');
    if (!inputs.length) return; // Guard C: do nothing on pages without pickers

    inputs.forEach(el => {
        if ((el as any)._flatpickr) return; // per-element idempotency guard (D-15)
        flatpickr(el, {
            dateFormat: 'Y-m-d',  // LOCKED — matches PHP-side validation (D-12)
            allowInput: true,      // D-11: manual keyboard entry
            // disableMobile: false (default) — native OS picker on mobile (D-11/D-03)
        });
    });
}
